const { Typography } = require("antd");

export default function InitialAvatar({ initials, check }) {
  const { Text } = Typography;
  return (
    <div>
      <Text
        style={{
          width: `${check}px`,
          height: `${check}px`,
          lineHeight: `${check}px`,
          fontSize: " 24px",
          ...(check ? { fontSize: " 24px" } : { fontSize: " 14px" }),
          backgroundColor: "#112D4E",
          color: "white",
        }}
        className="ant-avatar ant-avatar-circle ant-avatar-image"
      >
        {initials}
      </Text>
    </div>
  );
}
